export const environment = {
  production: true,

  SERVER_HOST: 'https://api.pharmox.fr/',
  API_PATH: 'https://api.pharmox.fr/api'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts